export default __webpack_public_path__ + "media/titles/title_1_locale_fr-5c2b6735.png";